import React, { useEffect, useState } from 'react';
import starIcon from '../../Assets/imgNewUI/head-star.png';
import defaultCardImg from "../../Assets/imgNewUI/creditPlaceHolder.png";
import debitDefaultCardImg from "../../Assets/imgNewUI/debitPlaceHolder.png";
import PropTypes from 'prop-types';
import { ApiConfigData, formatIndianNumber, UtilityReducer } from '../../Utility/Utility';
import PointIcon from "../../Assets/imgNewUI/point-coin-2.png";
import SavingAccountIcon from "../../Assets/imgNewUI/Debit-Card.svg";
import getTranslation from '../../TranslationUtility/TranslationUtility';
import CardModal from '../CardModal/CardModal';
import CardLoader from '../CardLoader';
import { onSaveIamge } from '../../Store/Slices/utilityReducer';
import { useDispatch } from 'react-redux';
// Import styles if needed

// Reference: CardSection.js
// This component displays a section of cards, accepts children, and supports loading/modal state via props.

const NewCardSection = ({
    title,
    cardLoader,
    selectedCard,
    selectCard,
    isOpen,
    setIsOpen,
    loading,
    ...rest
}) => {
    const dispatch = useDispatch();
    const translation = getTranslation();
    const card = UtilityReducer();
    const creditCards = card?.creditCards.filter(card => card.status === "1");

    const debitCards = card?.debitCards.filter(card => card.status === "1");
    const autoSelect = sessionStorage.getItem("autoSelect");
    // Per-card loading state
    const [loadingCardIdx, setLoadingCardIdx] = useState(null);
    const [cardType, setCardType] = useState(null);
    useEffect(() => {
        if (loadingCardIdx !== null) {
            const timer = setTimeout(() => setLoadingCardIdx(null), 1000);
            return () => clearTimeout(timer);
        }
    }, [loadingCardIdx]);


    const handleCardSelection = (loadingIndex, index, type, card, callApi, defaultCard, e) => {
        setLoadingCardIdx(loadingIndex);
        setCardType(type);
        e && e.stopPropagation();
        sessionStorage.setItem("autoSelect", true);
        selectCard(index, type, card, callApi, defaultCard);
        if (!callApi) {
            dispatch(
                onSaveIamge({
                    currentPoints: card?.pointBalance,
                    currentBg: card?.imagelink,
                    cardName: card.CardTypeName,
                    totalPointBalance: card?.totalPointBalance,
                })
            );
        }
    };

    const finalCredicards = creditCards?.filter(
        (card) => card?.identifiertype === "1002"
    );
    const finalDebitcards = creditCards?.filter(
        (card) => card?.identifiertype === "1001"
    );

    const creditCardsSorted = (creditCards || []).slice().sort((a, b) => {
        const aBalance = typeof a.pointBalance === 'number' ? a.pointBalance : 0;
        const bBalance = typeof b.pointBalance === 'number' ? b.pointBalance : 0;
        return bBalance - aBalance;
    });
    const apiconfig = ApiConfigData();
    const savingAccountLink = apiconfig?.find(
        (data) => data?.paramsKey === "savingAccountLink"
    )?.paramsValue;
    const creditCardLink = apiconfig?.find(
        (data) => data?.paramsKey === "creditCardLink"
    )?.paramsValue;

    return (
        <section className="new-card-section" {...rest}>
            {title && <h2 className="new-card-section__title"><img src={starIcon} alt="Icon" /> {title} <img src={starIcon} alt="Icon" /></h2>}
            {/* Loader example */}
            <>
                <div className="new-card-section__content">
                    {finalCredicards?.length > 1 ? (
                        creditCardsSorted.slice(0, 2).map((card, index) => (
                            <div key={index} className="card-item-new">
                                <div className='card-image'>
                                    <img src={card.backgroundcolor || defaultCardImg} alt={card.cardName} onError={(e) => (e.target.src = defaultCardImg)} />
                                </div>
                                <div className='card-balace'>
                                    <div className="card-point-icon"><img src={PointIcon} alt="Card not found" /> </div>
                                    <div className="card-points text-gradient">
                                        {typeof card.pointBalance === "number" && card.pointBalance === 0
                                            ? 0
                                            : (typeof card.pointBalance === "undefined" || !card.pointBalance)
                                                ? (loadingCardIdx === index && cardType === "credit"
                                                    ? <CardLoader />
                                                    : <div onClick={(e) => handleCardSelection(
                                                        index,
                                                        card?.identifier,
                                                        "credit",
                                                        card,
                                                        true,
                                                        selectedCard?.index === card?.identifier,
                                                        e
                                                    )}>{translation?.tryAgain}</div>)
                                                : formatIndianNumber(Math.floor(card.pointBalance))
                                        }
                                    </div>
                                </div>
                            </div>
                        ))
                    ) : (<>
                        {finalCredicards?.length > 0 && creditCardsSorted?.slice(0, 2).map((card, index) => (
                            <div key={index} className="card-item-new">
                                <div className='card-image'>
                                    <img src={card.backgroundcolor || defaultCardImg} alt={card.cardName} onError={(e) => (e.target.src = defaultCardImg)} />
                                </div>
                                <div className='card-balace'>
                                    <div className="card-point-icon"><img src={PointIcon} alt="Card not found" /> </div>
                                    <div className="card-points text-gradient">
                                        {typeof card.pointBalance === "number" && card.pointBalance === 0
                                            ? 0
                                            : card.pointBalance
                                                ? formatIndianNumber(Math.floor(card.pointBalance))
                                                : loadingCardIdx === index && cardType === "credit"
                                                    ? <CardLoader />
                                                    : <div onClick={(e) => handleCardSelection(
                                                        index,
                                                        card?.identifier,
                                                        "credit",
                                                        card,
                                                        true,
                                                        selectedCard?.index === card?.identifier,
                                                        e
                                                    )}>{translation?.tryAgain}</div>
                                        }
                                    </div>
                                </div>
                            </div>
                        ))}
                        {finalCredicards?.length === 1 && creditCardsSorted?.length === 1 && finalDebitcards?.length > 0 && finalDebitcards?.slice(0, 1).map((card, index) => (
                            <div key={index} className="card-item-new">
                                <div className='card-image'>
                                    <img src={SavingAccountIcon || debitDefaultCardImg} alt={card.cardName} onError={(e) => (e.target.src = debitDefaultCardImg)} />
                                </div>
                                <div className='card-balace'>
                                    <div className="card-point-icon"><img src={PointIcon} alt="Card not found" /> </div>
                                    <div className="card-points text-gradient">
                                        {typeof card.pointBalance === "number" && card.pointBalance === 0
                                            ? 0
                                            : card.pointBalance
                                                ? formatIndianNumber(Math.floor(card.pointBalance))
                                                : loadingCardIdx === index && cardType === "debit"
                                                    ? <CardLoader />
                                                    : <div onClick={(e) => handleCardSelection(
                                                        index,
                                                        card?.identifier,
                                                        "debit",
                                                        card,
                                                        true,
                                                        selectedCard?.index === card?.identifier,
                                                        e
                                                    )}>{translation?.tryAgain}</div>
                                        }
                                    </div>
                                </div>
                            </div>
                        ))}
                        {finalCredicards?.length === 0 && finalDebitcards?.length > 0 && finalDebitcards?.slice(0, 2).map((card, index) => (
                            <div key={index} className="card-item-new">
                                <div className='card-image'>
                                    <img src={SavingAccountIcon} alt={card.cardName} />
                                </div>
                                <div className='card-balace'>
                                    <div className="card-point-icon"><img src={PointIcon} alt="Card not found" /> </div>
                                    <div className="card-points text-gradient">
                                        {typeof card.pointBalance === "number" && card.pointBalance === 0
                                            ? 0
                                            : card.pointBalance
                                                ? formatIndianNumber(Math.floor(card.pointBalance))
                                                : loadingCardIdx === index
                                                    ? <CardLoader />
                                                    : <div onClick={(e) => handleCardSelection(
                                                        index,
                                                        card?.identifier,
                                                        "credit",
                                                        card,
                                                        true,
                                                        selectedCard?.index === card?.identifier,
                                                        e
                                                    )}>{translation?.tryAgain}</div>
                                        }
                                    </div>
                                </div>
                            </div>
                        ))}



                        {finalCredicards?.length === 1 && finalDebitcards?.length === 0 && (
                            <div className="card-item-new emptyBox" onClick={() => window.open(savingAccountLink, '_blank')}>
                                <i className="fa fa-plus icon-color"></i>
                                <div className='head-txt'>{translation?.GetSavingAccount}</div>
                                <div className='sub-txt'>{translation?.Get750off}</div>
                            </div>
                        )}
                        {finalDebitcards?.length > 0 && finalCredicards?.length === 0 && (
                            <div className="card-item-new emptyBox" onClick={() => window.open(creditCardLink, '_blank')}>
                                <i className="fa fa-plus icon-color"></i>
                                <div className='head-txt'>{translation?.GetCreditCard}</div>
                                <div className='sub-txt'>{translation?.Get750offCC}</div>
                            </div>
                        )}
                    </>)}
                </div>
                {creditCards?.length > 1 && (
                    <div className="more-cards-indicator" onClick={setIsOpen}>
                        {translation?.viewAll}
                    </div>
                )}
            </>
            {/* Modal example */}
            {
                creditCards?.length > 1 && isOpen && (
                    <CardModal
                        selectedCard={selectedCard}
                        debitCards={debitCards}
                        creditCards={creditCards}
                        isOpen={isOpen}
                        setIsOpen={setIsOpen}
                        selectCard={selectCard}
                        autoSelect={autoSelect}
                        cardData={card}
                        loading={loading}
                    />
                )
            }
        </section >
    );
};

NewCardSection.propTypes = {
    title: PropTypes.string,
    children: PropTypes.node,
    isLoading: PropTypes.bool,
    setIsLoading: PropTypes.func,
    isModalOpen: PropTypes.bool,
    setIsModalOpen: PropTypes.func,
};

NewCardSection.defaultProps = {
    title: '',
    isLoading: false,
    isModalOpen: false,
};

export default NewCardSection;